<template>
    <div>
      <van-nav-bar
        title="活动详情"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/activity')"
      />
      <div v-html="content" class="content">

      </div>
      <span><van-button type="danger" size="large" @click="cancelCoupon" style="width: 40%;margin-left: 7%;height: 30%; padding:3px;margin-top:40px;border-radius:6px">取消
          </van-button>
          <van-button type="danger" size="large" @click="goToRegisterPage" style="width: 40%;margin-left: 5%; height: 30%;padding:3px;margin-top:40px;border-radius:6px">立即注册
          </van-button>
          </span>


    </div>
</template>

<script>
    export default {
      name: "Couponinfo",
      data(){
        return{
          content:''
        }
      },
      methods:{
         loadImg(){
          },
        cancelCoupon() {
          this.$router.push('/home');
        },
        goToRegisterPage() {
          localStorage.setItem('reCouponCode', this.$route.query.code);
            // window.localStorage.setItem("rePhone", this.$route.query.code);
            // console.log("codddddddddddddd"+this.$route.query.code)
          this.$router.push('/login/register?code='+this.$route.query.code);
        },
        getActivityDetail(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'new_user_coupon_web_mobile',
                'coupon_id': that.$route.query.code,
                type:1
              }
            })
            .then(ret => {
              let resData = ret.data;
              // console.log(resData);
              if (resData.code === 1){
                that.content = resData.data;https://hk9999b.com/#/stockguild?activityid=31
                that.content = that.content.replace("https://hk9999b.com/#/stockguild?activityid=31", " #/activity/activity_detail?activityid=17");
                // that.content = that.content.replace("http://wonder.apps/withdraw","#/member/withdrawal");
                // that.content = that.content.replace("http://wonder.apps/realname_auth","#/member/information/real_name");
                // that.content = that.content.replace("http://wonder.apps/register","#/registered");
                // that.content = that.content.replace("http://wonder.apps/login","#/login");
                // that.content = that.content.replace("http://wonder.apps/trading","#/activity/activity_detail?activityid=20");
              }else{
                that.$toast.fail(resData.msg);
              }
            });
        }
      },
      mounted: function () {
        let that = this;
        if(this.$route.query.code.length == 9) {
          this.$router.push('/couponinfo?code='+this.$route.query.code);
        } else {
            // text = window.location.origin+"#/login/register?code="+coded;
             // text = window.location.origin+"#/couponinfo/?code="+this.$route.query.code;
          this.$router.push('/login/register?code='+this.$route.query.code);
        }
        this.getActivityDetail();
      },
    }
</script>

<style scoped>
  .content{
    width: 100%;
  }
  .content>>>img{
    width: 100%;
  }
  .content>>>p{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Couponinfo.vue